var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscounts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11Z",
    fill: "#306BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C9.55228 17 10 16.5523 10 16C10 15.4477 9.55228 15 9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17Z",
    fill: "#306BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.15 3C20.775 2.84615 20.4 3.15385 20.25 3.53846C20.175 3.92308 20.4 4.38462 20.775 4.46154C21.825 4.76923 22.5 5.30769 22.5 5.84615C22.5 6.53846 21.225 7.38462 19.5 7.38462V4.30769C19.5 3 18.525 2 17.25 2H11.4C10.575 2 9.825 2.30769 9.3 2.92308L0.75 11.6923C0.3 12.1538 0 12.8462 0 13.5385C0 14.2308 0.3 14.9231 0.75 15.3846L6.45 21.2308C6.9 21.6923 7.575 22 8.25 22C8.925 22 9.6 21.6923 10.05 21.2308L18.6 12.4615C19.125 11.9231 19.425 11.2308 19.5 10.5385C19.5 10.0769 19.2 9.76923 18.825 9.69231C18.375 9.61538 18.075 10 18 10.3846C18 10.7692 17.85 11.0769 17.55 11.3846L9 20.1538C8.625 20.5385 7.875 20.5385 7.5 20.1538L1.8 14.3077C1.575 14.0769 1.5 13.8462 1.5 13.5385C1.5 13.2308 1.575 13 1.8 12.7692L10.35 4C10.65 3.69231 11.025 3.53846 11.4 3.53846H17.25C17.7 3.53846 18 3.84615 18 4.30769V7.15385C17.1 6.84615 16.5 6.30769 16.5 5.84615C16.5 5.38462 16.2 5.07692 15.75 5.07692C15.3 5.07692 15 5.38462 15 5.84615C15 7.53846 16.95 8.92308 19.5 8.92308C22.05 8.92308 24 7.53846 24 5.84615C24 4.53846 22.875 3.46154 21.15 3Z",
    fill: "#306BF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9382 10.4553C12.7768 10.0345 12.2929 9.86614 11.8895 10.1186L5.43636 13.4851C5.03304 13.6534 4.87171 14.1584 5.1137 14.5792C5.19436 14.8317 5.43636 15 5.75902 15C5.83968 15 6.00101 15 6.08168 14.9158L12.5349 11.5494C12.9382 11.2969 13.0995 10.7919 12.9382 10.4553Z",
    fill: "#306BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscounts);
export default __webpack_public_path__ + "static/media/discounts.df3e29c9e0bab7f245aebfbc99d04943.svg";
export { ForwardRef as ReactComponent };